var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload",style:({width:(_vm.width || '95') + 'px',height:(_vm.height || '95') + 'px'})},[_c('img',{staticClass:"img",attrs:{"src":_vm.img,"alt":""}}),_vm._v(" "),_c('input',{staticClass:"uploader-input",attrs:{"type":"file","accept":"image/*","name":"uploader-input"},on:{"change":_vm.uploadImage}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4553ebf5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uplaodImage.vue
// module id = null
// module chunks = 